<template>
	<i class="w-8 h-8 flex items-center justify-center">
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="currentColor"
		>
			<path
				d="M23 24H29.3333V26.6667H20.3333L23 24ZM6.33333 26.6667L3.5 23.8333C2.98889 23.3222 2.72777 22.6889 2.71666 21.9333C2.70555 21.1778 2.95555 20.5333 3.46666 20L18.1333 4.8C18.6444 4.26667 19.2722 4 20.0167 4C20.7611 4 21.3889 4.25556 21.9 4.76667L28.5333 11.4C29.0444 11.9111 29.3 12.5444 29.3 13.3C29.3 14.0556 29.0444 14.6889 28.5333 15.2L17.3333 26.6667H6.33333Z"
			/>
		</svg>
	</i>
</template>
